import { usePage } from "@inertiajs/react";
import isHotkey from "is-hotkey";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import QuickSearchButton from "components/search/QuickSearchButton/QuickSearchButton";
import Icon from "hardcover-ui/components/Icon";
import useMount from "hooks/useMount";
import faSearch from "icons/solid/magnifying-glass.svg";
import { searchActions } from "store/search/searchSlice";
import { DefaultPageType } from "types/DefaultPageType";

export default function QuickSearchButtonWrapper(): JSX.Element {
  const { pathName } = usePage<DefaultPageType>().props;
  const dispatch = useDispatch();
  const isMounted = useMount();

  const [searchText, setSearchText] = useState("⌘ K");

  const onKeyDown = (e: KeyboardEvent) => {
    if (isHotkey("mod+k", e)) {
      dispatch(searchActions.toggleSearchVisible());
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (pathName?.startsWith("/search")) {
      return;
    }

    window.addEventListener("keydown", onKeyDown);
    if (window.navigator.userAgent.indexOf("Mac") === -1) {
      setSearchText("CTRL K");
    }
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [pathName]);

  // Don't render search button if we're on the search page
  if (pathName?.startsWith("/search")) {
    return <></>;
  }

  return (
    <QuickSearchButton
      className={`bg-gray-100 dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900 max-w-32 md:max-w-64 sm:text-sm ring-2 ring-inset ring-gray-200 dark:ring-gray-500 rounded-lg px-2 py-2 flex justify-between items-center transition-all ${
        isMounted ? "cursor-pointer" : "cursor-not-allowed opacity-50"
      }`}
    >
      <>
        <div className="flex flex-row items-center">
          <Icon
            icon={faSearch}
            className="h-5 w-5 fill-gray-700 dark:fill-gray-400"
          />
          <span className="ml-2 font-semibold text-gray-700 dark:text-gray-400 whitespace-nowrap">
            Search
          </span>
        </div>
        <span
          className={`ml-12 bg-gray-300 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-1 py-0.5 rounded-sm font-bold whitespace-nowrap ${
            isMounted ? "cursor-pointer" : "cursor-not-allowed"
          }`}
        >
          {searchText}
        </span>
      </>
    </QuickSearchButton>
  );
}
